import { RouteComponentProps } from 'react-router-dom';

import { ReactComponent as DotsWithLinesIcon } from 'assets/images/dots-with-lines.svg';

import styles from './styles.module.scss';

export const NoChosenCompany: React.FC<RouteComponentProps> = () => {
  return (
    <div className={styles.container}>
      <DotsWithLinesIcon />
      <p>Select company to start managing its artworks and users</p>
    </div>
  );
};
